import React, { useEffect, useState } from "react";
import "../NewsletterPage.css";  

import { FaHeart, FaSearch } from "react-icons/fa"; 
import UnauthorizedNavbar from "./unauthorizedNavbar";

import UnauthorizedFooter from "./unauthorizedFooter";
import { useNavigate } from "react-router-dom";
import FloatingSocialIcons from "./FloatingSocialIcons";
const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = window.sessionStorage.getItem("jwtToken");

const NewsletterPage = () => {
    const [newsletters, setNewsletters] = useState([]);
    const [likes, setLikes] = useState({});
    const [likedStatus, setLikedStatus] = useState({});
    const [searchQuery, setSearchQuery] = useState("");
    const [visibleCount, setVisibleCount] = useState(9); 
    const [showAllPopular, setShowAllPopular] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const latestEntry = newsletters.length > 0 ? newsletters[0] : null;
    const navigate = useNavigate(); 
    const [visibleCategories, setVisibleCategories] = useState();
    const allCategories = [...new Set(newsletters.flatMap(news => news.categories || []))];
    const displayedCategories = allCategories.slice(0, visibleCategories);
    const [showSearch, setShowSearch] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false); 
    const [selectedCategory, setSelectedCategory] = useState("All");
// const [searchQuery, setSearchQuery] = useState("");




    useEffect(() => {
        fetch(`${BASE_URL}/fetchNewsLetterAndBlogs`)
            .then((response) => response.json())
            .then((data) => {
                if (Array.isArray(data)) {
                    const sortedData = [...data].sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate));
                    console.log("Sorted by publishedDate:", sortedData.map(item => item.publishedDate));

                    setNewsletters(sortedData);

                    const initialLikes = sortedData.reduce((acc, news) => {
                        acc[news.id] = news.likesCount || 0;
                        return acc;
                    }, {});
                    setLikes(initialLikes);
                    setLikedStatus({});
                } else {
                    console.error("Unexpected API response format", data);
                    setNewsletters([]);
                }
            })
            .catch((error) => console.error("Error fetching data:", error));
    }, []);

    

    const handleLike = (id) => {
        const isLiked = likedStatus[id];
        const newLikeCount = isLiked ? likes[id] - 1 : likes[id] + 1;

        setLikes((prevLikes) => ({
            ...prevLikes,
            [id]: newLikeCount,
        }));

        setLikedStatus((prevStatus) => ({
            ...prevStatus,
            [id]: !isLiked,
        }));

        fetch(`${BASE_URL}/${id}/like`, { method: "Post" , Authorization: `Bearer ${token}`})
            .then((response) => response.json()) 
            .then((data) => {
                setLikes((prevLikes) => ({
                    ...prevLikes,
                    [id]: data.likesCount, 
                }));
            })
            .catch((error) => {
                console.error("Error updating like count", error);
            });
    };

    
    const filteredNewsletters = newsletters
    .slice(1)
    .filter(news => {
        const matchesSearch = news.text.toLowerCase().includes(searchQuery.toLowerCase());

        const matchesCategory =
            !selectedCategory || selectedCategory === "All"
                ? true
                : (news.categories || []).includes(selectedCategory);

        return matchesSearch && matchesCategory;
    })
    .sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate));



    const filteredMostPopularVideos = [...newsletters]
    // 2. Sort by likes then date
    .sort((a, b) => {
        const likeDiff = (b.likesCount || 0) - (a.likesCount || 0);
        if (likeDiff !== 0) return likeDiff;
        return new Date(b.publishedDate) - new Date(a.publishedDate);
    })

    // 3. Show all or first 4
    .slice(0, showAllPopular ? newsletters.length : 4);

 

    const handleRedirect = (news) => {
        const newState = { 
            text: news.text, 
            description: news.description,
            backgroundImage: news.backgroundImage, 
            publishedDate: news.publishedDate,
            likesCount: likes[news.id] || 0,
            id: news.id,
            categories : news.categories,
            htmlPageLink : news.htmlPageLink
        };
        console.log("Navigating with state:", newState);
        setTimeout(() => {
             const fileName = news.htmlPageLink
                   ?.split("/")
                   ?.pop()
                   ?.replace(".html", "");

        navigate(`/blogs/${fileName}`, { state: newState });

        }, 100);
    };
        
    const handleCategoryClick = (category) => {
        if (selectedCategory === category) {
            setSelectedCategory("All"); // clicking same again goes back to all
            return;
        }
        setSelectedCategory(category);
    };

    return (
    <>
    <UnauthorizedNavbar/>
    <div style={{background: 'linear-gradient(to bottom right, #f1e8f7, #fdf4e7)'}}>
        <div className = "container" style={{height:'100%',  minHeight: '100%'  }}>
            {latestEntry && (
                <div className="latest-entry-container">
                    <div className="latest-entry-content">
                        <a href="#" onClick={() => handleRedirect(latestEntry)}>
                            <img 
                                src={latestEntry.backgroundImage} 
                                alt="icon" 
                                className="latest-entry-image" 
                            />
                        </a>
                        <div className="latest-entry-text">
                            <h6 className="mb-1">
                                <a href="#" onClick={() => handleRedirect(latestEntry)}
                                    className="fw-bold text-decoration-none latest-entry-title">
                                    {latestEntry.text}
                                </a>
                            </h6>
                             <p href="#" onClick={() => handleRedirect(latestEntry)}
                                    className="blog-description">
                                    {latestEntry.description}
                            </p>
                            <div className="latest-entry-footer">
                                <small className="text-muted date-text">
                                    {new Date(latestEntry.publishedDate).toDateString().toUpperCase()}
                                </small>
                                <a className="read-more-text"href="#" onClick={() => handleRedirect(latestEntry)}>
                                    Read More...
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}

  
            {/* <div className="most-popular-container">
                <div className="most-popular-header">
                    <h5 className="fw-bold" style={{ paddingLeft: "20px", color:"#000000ff" }}>Most Popular</h5>
                </div>
                <div className="container" style={{ width: "100%" }}>
                    <div className="row row-cols-1 row-cols-md-4 g-4">
                        {filteredMostPopularVideos.map((news) => (
                            <div key={news.id} className="col-12 col-md-3">
                                <div className="mini-popular-card" onClick={() => handleRedirect(news)}>
                                    
                                    <img
                                        src={news.backgroundImage}
                                        className="mini-thumb"
                                        alt={news.text}
                                    />

                                    <div className="mini-content">
                                        <h6 className="mini-title">{news.text}</h6>
                                        <p className="mini-date">
                                            {new Date(news.publishedDate).toDateString()}
                                        </p>
                                    </div>

                                </div>
                            </div>

                        ))}
                    </div>
                </div>
            </div> */}

            
            <div className="page-container" style={{ width: "100%", paddingBottom: "100px" }}>
                <div className="category-list">

                    {/* ALL option */}
                    <button
                        className={`category-button fw-bold ${selectedCategory === "All" ? "active" : ""}`}
                        onClick={() => handleCategoryClick("All")}
                    >
                        All
                    </button>

                    {/* Existing categories */}
                    {displayedCategories.map((category, idx) => (
                        <button 
                            key={idx}
                            className={`category-button fw-bold ${selectedCategory === category ? 'active' : ''}`}
                            onClick={() => handleCategoryClick(category)}
                        >
                            {category}
                        </button>
                    ))}
                </div>
                <div className="site-container">
                    {filteredNewsletters.slice(0, visibleCount).map((news) => (
                        <div
                            key={news.id}
                            className="blog-post-box h-100 overflow-hidden"
                            
                            onMouseEnter={() => setIsHovered(news.id)}
                            onMouseLeave={() => setIsHovered(null)}
                        >
                            <div>
                                <a  href="#"
                                    onClick={() => handleRedirect(news)}  title={news.text}>
                                    <img src={news.backgroundImage} alt="icon" className="image  w-100" />
                                </a>
                            </div>
                            <div className="body">
                                {/* <p style={{ fontSize:'12.24px', paddingLeft:'10px', paddingRight:'10px',
                                    paddingTop:'5px', paddingBottom:"5px", display: 'inline', color:'rgb(242, 150, 11)'}}>{news.categories} </p> */}
                                <h3 className="title-wrapper">
                                <a
                                    href="#"
                                    onClick={() => handleRedirect(news)}
                                    title={news.text}
                                    className="title-link"
                                >
                                    {news.text}
                                </a>
                                </h3>
                                <p
                                    href="#"
                                    onClick={() => handleRedirect(news)}
                                    title={news.description}
                                    className="blog-description"
                                >
                                    {news.description}
                                </p>
                                <div className="date-text">
                                    PUBLISHED: {new Date(news.publishedDate).toDateString().toUpperCase()}
                                </div>
                                <a className="read-more-text"href="#"onClick={() => handleRedirect(news)}>
                                    Read More...
                                </a>
                            </div>
                            
                        </div>
                    ))}
                </div>
                {newsletters.length > 8 && (
                    <div className="load-more-container" style={{marginTop:"10px"}}>
                        <button
                        className="load-more-button"
                        onClick={() => {
                            if (visibleCount >= newsletters.length) {
                            setVisibleCount(9);
                            } else {
                            setVisibleCount((prev) => prev + 9);
                            }
                        }}
                        >
                        {visibleCount >= newsletters.length ? "Load Less >" : "Load More >"}
                        </button>
                    </div>
                )}
            </div>
        </div>
    </div>    
    <UnauthorizedFooter style={{justifyContent:'end'}} />
    </>
    );
};

export default NewsletterPage;







